import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Permet de définir l'icon à afficher sur le filtre de type d'équipement
 * @param {string} value - pour afficher la valeur du filtre
 * @param {string} color - couleur du filtre à afficher
 * @param {string} ticketText - texte du filtre à afficher
 */
export default function IconsStatus({ value, ticketText, color }) {
  const [className, setClassName] = useState(null);
  const { t } = useTranslation();

  const statusMap = {
    green: [
      "Opérationnel",
      "Rapport d'incident publié",
      "Résolu",
      "Service restauré",
      "Faux positif",
      "Question",
      "connected",
      "connected_with_issues",
      "Connected",
      "Free",
      "FreeUntil",
      "True",
      "Available",
      "Staring",
      "Active",
      "Started",
      "On",
      "OK",
      "YES",
      "OUI",
      "Protect",
      "not_isolated",
      "SLA RESPECTE",
      "VA",
      "Encrypted",
      "online",
      "true",
      "Online",
      "5",
      "ACTIVE",
      "resolved",
      "protect",
      "No",
      "False positive",
      "Resolved"
    ],
    yellow: [
      "Basse S4",
      "Open",
      "Probleme",
      "Vérification",
      "Correction",
      "normal",
      "alerting",
      "Alerting",
    ],
    orange: [
      "connected_with_issues",
      "Restauration",
      "Stopped",
      "BookedUntil",
      "Unstable",
      "Domain Controller",
      "Haute S2",
      "Incident",
      "alerting",
      "high",
      "Non résolu",
      "warning",
      "suspicious"
    ],
    red: [
      "NotConnected",
      "disconnected",
      "offline_expired",
      "False",
      "Off",
      "Stopped",
      "Disabled",
      "Inactive",
      "NotFound",
      "NO",
      "NON",
      "isolated",
      "Audit",
      "Moyenne S3",
      "SLA DEPASSE",
      "alerting",
      "false",
      "Incident hors-contrat",
      "offline",
      "Interruption",
      "Dégradation",
      "critical",
      "Offline",
      "EXPIRED",
      "unprotected",
      "Yes",
      "Unresolved",
      "malicious",
    ],
    darkRed: ["Critique S1"],
    grey: [
      "unknown",
      "Unknown",
      "Not supported",
      "dormant",
      "Question",
      "Investigation suspendue",
      "indisponible",
      "Unavailable"
    ],
    blue: ["Changement", "Changement mineur", "Machines W7", "created", "Preferred"],
    blue_lavande_pastel: ["Other Hardware"],
    red_pink_pastel: ["Desktop Request"],
    green_blue_pastel: ["Change request"],
    orange_yellow_pastel: ["Quick Time"],
    marine: ["Changement majeur", "Auto"],
    purple : [
      "Service Request"
    ]
  };

  // Définir la classe pour avoir la bonne couleur
  useEffect(() => {
    Object.entries(statusMap).forEach(([key, status]) => {
      if (status.includes(value)) {
        setClassName(key);
      }
    });
  }, [value]);

  // Formater la valeur pour l'afficher en majuscules et sans soulignement
  const formatValue = () => {
    let valueForm =
      typeof value === "string"
        ? value.charAt(0).toUpperCase() + value.slice(1).replaceAll("_", " ")
        : value;
    if (valueForm === "Connected with issues") {
      valueForm = t("Issues");
    } else if (valueForm === "Domain Controller") {
      valueForm = t("Domain ctrl");
    } else {
      return t(valueForm);
    }
    return t(valueForm);
  };

  return (
    <>
      <p className={`${color ? color : className ? className : "text"}`}>
        <span className="status-value" title={t(ticketText || formatValue())}>
          {ticketText ? t(ticketText) : formatValue()}
        </span>
      </p>
    </>
  );
}
